import { Col, Row } from "antd";

export  const CustomHeaderFooter = ({ title }) => (
    <div style={{ width: "100%" }}>
      {" "}
      {/* Wrapper to ensure full width */}
      <Row
        justify="space-between"
        className="displayFlex alignItems alignContent"
        style={{
          borderBottom: "1px solid #e2e2e2",
          backgroundColor: "#f5f5f5",
          transform: "translateY(-20px)",
          borderRadius: "8px 8px 0 0",

          margin: "0 -24px",

          padding: "15px",
        }}
      >
        <Col span={24}>
          <span className="gx-mb-3">{title}</span>
        </Col>
      </Row>
    </div>
  );